import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import 'src/layouts/index.css';
import NavBar from './NavBar';
import EventEmitter from 'src/utils/EventEmitter';
import useStateRef from "react-usestateref";
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { CloseSnackbarAction } from 'src/components/CloseSnackbarAction';
import { CheckExpiredToken } from 'src/components/CheckeExpiredToken';
import NotificationPage from 'src/layouts/DashboardLayout/Notification/NotificationPage';
import NotificationCustomPage from 'src/layouts/DashboardLayout/NotificationCustom/index';
import Sidebar from 'src/layouts/DashboardLayout/Sidebar';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import PopupCustomView from 'src/layouts/DashboardLayout/PopupCustom/index';
import SelectMenuPage from './SelectMenu/SelectMenuPage';
import NavBarBottom from 'src/layouts/DashboardLayout/NavBar/NavBarBottom';
import { useNavigate } from "react-router-dom";
import { LoadingView } from 'src/components/LoadingView';
import CloseIcon from '@mui/icons-material/Close';
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { useAxiosInstance } from 'src/utils/useAxiosInstance';

const DashboardLayout = () => {
  /* eslint-disable */
  const { enqueueSnackbar } = useSnackbar();
  const [showFull, setShowFull] = useState(false);

  const [notificationBanner, setNotificationBanner, notificationBannerRef] = useStateRef("");
  const [showNotificationBanner, setShowNotificationBanner, showNotificationBannerRef] = useStateRef(false);
  const [showNotification, setShowNotification] = useState(false);
  const [showNotificationType, setShowNotificationType] = useState('');
  const [showAlert, setShowAlert, showAlertRef] = useStateRef(false);
  const [showHotjarScript, setShowHotjarScript, showHotjarScriptRef] = useStateRef(false);

  const alertDataDefault = {
    icon: "",
    header: "",
    content: ""
  }
  const [alertData, setAlertData, alertDataRef] = useStateRef(alertDataDefault);
  const [showAlertType, setShowAlertType, showAlertTypeRef] = useStateRef(null);
  const [showWithoutSidebar, setShowWithoutSidebar, showWithoutSidebarRef] = useStateRef(null);
  const [showCustomPopup, setShowCustomPopup, showCustomPopupRef] = useStateRef(false);
  const [showSelectMenu, setShowSelectMenu, showSelectMenuRef] = useStateRef(false);
  const [currentSelectMenu, setCurrentSelectMenu, currentSelectMenuRef] = useStateRef(0);
  const [currentCategory, setCurrentCategory, currentCategoryRef] = useStateRef([]);
  const [currentDoseFormat, setCurrentDoseFormat, currentDoseFormatRef] = useStateRef([]);
  const [currentSupplierName, setCurrentSupplierName, currentSupplierNameRef] = useStateRef([]);
  const [selectMenuType, setSelectedMenuType, selectMenuTypeRef] = useStateRef("");
  const [showTopNavigationWithTitle, setShowTopNavigationWithTitle, showTopNavigationWithTitleRef] = useStateRef(false);
  const [title, setTitle, titleRef] = useStateRef('');
  const [customPopupType, setCustomPopupType, customPopupTypeRef] = useStateRef("");
  const [customData, setCustomData, customDataRef] = useStateRef("");
  const [userProfile, setUserProfile, userProfileRef] = useStateRef(null);
  const [company, setCompany, companyRef] = useStateRef("");
  const [loading, setLoading, loadingRef] = useStateRef(true);
  const navigate = useNavigate();
  const { user } = useAuth0();
  const { axiosInstance } = useAxiosInstance();

  /* eslint-enable */

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const splash = document.querySelectorAll('.splash');
    setTimeout(() => {
      for (var i = 0; i < splash.length; ++i) {
        splash[i].classList.add('display-none');
      }
    }, 2000)

    getUserProfile();

    // getBannerInfo();
    getGoogleAnalyticsTrackingId();

    const onShowFull = (eventData) => {
      setShowFull(eventData.value)
    }

    const listener = EventEmitter.addListener('show_full', onShowFull);

    const onShowNotification = (eventData) => {
      setShowNotification(eventData.value)
      setShowNotificationType(eventData.type)
    }

    const listener2 = EventEmitter.addListener('show_notification', onShowNotification);

    const onShowAlert = (eventData) => {
      setShowAlert(eventData.value);
      setAlertData({
        icon: eventData.icon,
        header: eventData.header,
        content: eventData.content
      });
    }

    const listener3 = EventEmitter.addListener('show_alert', onShowAlert);

    const onShowWithoutSidebar = (eventData) => {
      setShowWithoutSidebar(eventData.value);
    }

    const listener4 = EventEmitter.addListener('show_without_sidebar', onShowWithoutSidebar);

    const onShowCustomPopup = (eventData) => {
      setShowCustomPopup(eventData.value);
      checkTopNavigation('top_navigation_with_title', eventData.value);
      setTitle(eventData.title);
      setCustomPopupType(eventData.type);
      setCustomData(eventData.data);
    }

    const listener5 = EventEmitter.addListener('show_custom_popup', onShowCustomPopup);

    const onShowLoginAsCustomer = (eventData) => {
      setShowNotification(eventData.value)
      setShowNotificationType(eventData.type)
    }

    const listener6 = EventEmitter.addListener('show_login_as_customer', onShowLoginAsCustomer);

    const onShowSelectMenu = (eventData) => {
      setShowSelectMenu(eventData.value);
      if (eventData) {
        if (eventData.type) {
          setSelectedMenuType(eventData.type);
        }

        if (eventData.category) {
          setCurrentCategory(eventData.category)
        }

        if (eventData.dose_format) {
          setCurrentDoseFormat(eventData.dose_format);
        }

        if (eventData.supplier) {
          setCurrentSupplierName(eventData.supplier);
        }
      }
    };

    const listener7 = EventEmitter.addListener("show_select_menu", onShowSelectMenu);

    return () => {
      listener.remove();
      listener2.remove();
      listener3.remove();
      listener4.remove();
      listener5.remove();
      listener6.remove();
      listener7.remove();
    }
  }, []);

  const getHotJarScript = async () => {
    try {
      var area = "Cannatrek";
      var key = "HotJar_Id";

      await axios.get(`/csapi/settings?Area=${area}&Key=${key}`, {
      }).then(async response => {
        if (response) {
          if (response.data) {
            var data = response.data.Data.HotJar_Id;
            var location = window.location.pathname;

            if (data) {
              if (!(location === "/checkout" || location === "/invoices")) {
                const script = document.createElement("script");
                script.setAttribute("id", "hotjar-snippet");

                script.innerHTML = `
              (function(h,o,t,j,a,r){

                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        
                h._hjSettings={hjid:${data},hjsv:6};
        
                a=o.getElementsByTagName('head')[0];
        
                r=o.createElement('script');r.async=1;
        
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;

                r.setAttribute("id", "hotjar-snippet")
        
                a.appendChild(r);
        
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`

                document.head.appendChild(script)
              }
            } else {
              setShowHotjarScript(true);
            }
          }
        }
      })
    }
    catch (e) {
    }
  }

  const getUserProfile = async () => {
    try {
      await axiosInstance
      .get(`/consignment-partner/user`)
      .then((response) => {
        setUserProfile(response.data);
      });
    } catch (e) {
      console.error('Error fetching user profile:', e);
    }

    setLoading(false);
  };

  useEffect(() => {
    window.onpopstate = e => {
      checkLocation();
    };
  });


  useEffect(() => {
    checkLocation();
  }, [window.location.pathname]);

  const getGoogleAnalyticsTrackingId = async () => {
    try {
      await axios.get(`/csapi/greenship/general/google-analytics-tracking-id`, {
        headers: {
          "Content-Type": "application/json"
        },
      })
        .then(async response => {
          if (response.data) {
            if (response.data.Data) {
              if (response.data.Data.TrackingId) {
                const script = document.getElementById('google_analytics-script');
                if (script) {
                  script.src = "https://www.googletagmanager.com/gtm.js?id=" + response.data.Data.TrackingId;
                  var content = script.innerHTML;
                  script.innerHTML = content;
                }

                const iframe = document.getElementById('google_analytics-iframe');
                if (iframe) {
                  iframe.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=' + response.data.Data.TrackingId + ' height="0" width="0" style="display:none;visibility:hidden"></iframe>';
                } else {
                  const new_iframe = document.createElement('noscript');
                  new_iframe.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=' + response.data.Data.TrackingId + ' height="0" width="0" style="display:none;visibility:hidden"></iframe>';
                  new_iframe.id = "google_analytics-iframe";
                  document.body.appendChild(new_iframe);
                }
              }
            }
          }
        })
    } catch (e) {
    }
  }

  const closeAlert = () => {
    setShowAlert(false);
    setShowAlertType(null);
  }

  const checkTopNavigation = (type, value) => {
    var top_navigation_with_title = false;

    if (value) {
      if (type === "top_navigation_with_title") {
        top_navigation_with_title = true;
      }
    }

    setShowTopNavigationWithTitle(top_navigation_with_title);
  }

  const checkLocation = (prev_location) => {
    var location = window.location.pathname;
    if (prev_location) {
      location = prev_location;
    }

    if (location.includes("/catalogue/") || location.includes("/checkout")) {
      setShowWithoutSidebar(true);
    } else {
      setShowWithoutSidebar(false);
    }

    if (!showHotjarScriptRef.current) {
      if (location.includes("/checkout") || location.includes("/invoices")) {
        if (document.querySelectorAll("#hotjar-snippet")) {
          document.querySelectorAll("#hotjar-snippet").forEach(script => script.remove());
        }
      } else {
        if (document.querySelectorAll("#hotjar-snippet").length === 0) {
          getHotJarScript();
        }
      }
    }
  }

  const onClickBackArrow = () => {
    EventEmitter.emit("prev_step", { value: true });
  }

  const getBannerContent = () => {
    var string = notificationBannerRef.current;
    var value_list = string.split('<br/>');

    const list = [];

    value_list.map((value, index) => {
      list.push(<span key={index}>{value}</span>);
    });
    return <>{list}</>;
  };

  return (!loadingRef.current ?
    <div className="main-container-wrapper" style={{ height: "100%", position: "relative" }}>


      {showNotification ? <NotificationPage showNotificationType={showNotificationType} setShowNotification={setShowNotification} /> : ''}

      {showAlertRef.current ? <NotificationCustomPage alertData={alertDataRef.current} closeAlert={closeAlert} /> : ''}

      {showCustomPopupRef.current ? <div className="back-screen-popup" /> : ''}

      {showTopNavigationWithTitleRef.current ?
        <div className="top-wrapper-navigation-wrapper main">
          <div className="top-wrapper-navigation">
            <div className="item-navigation-wrapper" style={{ width: "30px" }}>
              <div className="required-arrow-left hide-desktop navigation" style={{ marginLeft: "0px", marginRight: "0px" }} onClick={() => onClickBackArrow()}>
                <ArrowBackRoundedIcon style={{ fontSize: "20px", marginLeft: "-2px" }} />
              </div>
            </div>

            <div className="top-navigation-title">{titleRef.current}</div>
            <div className="item-navigation-wrapper" style={{ width: "30px" }}></div>
          </div>
        </div>
        : ''}

      {showCustomPopupRef.current ? <PopupCustomView popupType={customPopupTypeRef.current} customData={customDataRef.current} /> : ""}

      <NavBar userProfile={userProfileRef.current} company={companyRef.current} />

      {showNotificationBannerRef.current ? (
        <div
          className={`notification-layout notification-layout-2 notification-layout-new
        ${showFull ||
              showNotification ||
              showCustomPopupRef.current
              ? 'full'
              : ''
            }
        ${showTopNavigationWithTitleRef.current ||
              showNotification ||
              showCustomPopupRef.current
              ? 'navigation'
              : ''
            }`}
        >
          <div className="content">
            <div className="content-wrapper">
              <div className="new-content-wrapper-2">
                <div className="new-notification-wrapper-desktop">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      maxHeight: '52px'
                    }}
                  >
                    <img
                      src="/static/images/icon/warning-icon-yellow.svg"
                      alt="warning-icon-yellow"
                      className="warning-icon-yellow"
                    />
                  </div>
                  <div className="new-notification-wrapper-text" style={{ display: "flex", alignItems: "center" }}>
                    {getBannerContent()}
                  </div>
                </div>
                <div className="new-notification-wrapper-mobile">
                  <div className="new-notification-wrapper-text">
                    {getBannerContent()}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="close-content new"
              onClick={() => setShowNotificationBanner(false)}
            >
              <CloseIcon />
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
      <div className="outlet-content-wrapper-container">
        {!showWithoutSidebarRef.current ? <Sidebar inventoryUrl={userProfile.partner.inventoryUrl} /> : ""}

        <div className={`outlet-content ${showWithoutSidebarRef.current ? "outlet-content-without-sidebar" : ''}`}>
          {/* <div className="outlet-content-wrapper" style={{ overflowX: showCustomPopupRef.current ? "hidden" : "overlay" }}> */}
          <div className={`outlet-content-wrapper ${showCustomPopupRef.current ? "overflow-x-hidden" : "overflow-x-overlay"}`}>
            <div className="outlet-content-right-content">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      <NavBarBottom />

      {showSelectMenuRef.current ? <SelectMenuPage currentSelectMenu={currentSelectMenuRef.current} selectMenuType={selectMenuTypeRef.current}
        category={currentCategoryRef.current} doseFormat={currentDoseFormatRef.current} supplier={currentSupplierNameRef.current} /> : ""}

    </div>
    : <LoadingView />
  );
};

export default withAuthenticationRequired(DashboardLayout, {
  onRedirecting: () => null,
});